import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { CriarOrcamentoFormData } from "../schema/criar-orcamento.schema";
import { EditarOrcamentoFormData } from "../schema/editar-orcamento.schema";
import { AprovarOrcamentoFormData } from "../schema/aprovar-orcamento.schema";
import { CancelarOrcamentoFormData } from "../schema/cancelar-orcamento.schema.ts";

const criar = async (data: CriarOrcamentoFormData): Promise<void> => {
    try {
        const response = await baseApiService.post('/budgets', data);
        return response.data.data;
    } catch (err) {
        console.error("Erro ao criar orçamento:", err);
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/budgets/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};


const findAll = async (
    query?: string,
    pagina = 0,
    limite = 10
): Promise<any> => {
    try {
        const page = pagina + 1;

        const url = query
            ? `/budgets?page=${page}&limit=${limite}&${query}`
            : `/budgets?page=${page}&limit=${limite}`;

        const response = await baseApiService.get(url);
        return response.data.data;

    } catch (error) {
        throw errosHandler(error);
    }
};

const editar = async (id: string, data: EditarOrcamentoFormData): Promise<void> => {
    try {
        await baseApiService.put(`/budgets/${id}`, data);
    }
    catch (err) {
        console.error("Erro ao editar orçamento:", err);
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<void> => {
    try {
        await baseApiService.delete(`/budgets/${id}`);
    }
    catch (err) {
        console.error("Erro ao deletar orçamento:", err);
        throw errosHandler(err);
    }
}

const aprovarOrcamento = async (id: string, data: AprovarOrcamentoFormData): Promise<void> => {
    try {
        await baseApiService.post(`/budgets/approve/${id}`, data);
    }
    catch (err) {
        console.error("Erro ao aprovar orçamento:", err);
        throw errosHandler(err);
    }
}

const cancelar = async (id: string, data: CancelarOrcamentoFormData): Promise<void> => {
    try {
        await baseApiService.post(`/budgets/cancel/${id}`, data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const duplicarOrcamento = async (id: string): Promise<void> => {
    try {
        await baseApiService.post(`/budgets/duplicate/${id}`);
    } catch (err) {
        throw errosHandler(err);
    }
}

const analisarComIA = async (budgetId: string, contextoAdicional?: string): Promise<any> => {
    try {
        const response = await baseApiService.post(`/budgets/analyze`, {
            budgetId,
            contextoAdicional,
        });
        return response.data.data;
    } catch (err) {
        console.error("Erro ao analisar orçamento com IA:", err);
        throw errosHandler(err);
    }
};

export const orcamentoService = {
    criar,
    findAll,
    detalhar,
    editar,
    deletar,
    aprovarOrcamento,
    cancelar,
    duplicarOrcamento,
    analisarComIA,
};